import { render, staticRenderFns } from "./BulkChangeUserBankDialog.vue?vue&type=template&id=0bb6067e&"
import script from "./BulkChangeUserBankDialog.vue?vue&type=script&lang=js&"
export * from "./BulkChangeUserBankDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports